var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3254_8530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.945 6.4275C18.7583 5.85 19.4425 5.12917 20 4.29917V4.29833C19.2558 4.62417 18.4642 4.84083 17.6375 4.94583C18.4875 4.43833 19.1367 3.64083 19.4417 2.68C18.6492 3.1525 17.7742 3.48583 16.8417 3.6725C16.0892 2.87083 15.0167 2.375 13.8467 2.375C11.5767 2.375 9.74917 4.2175 9.74917 6.47583C9.74917 6.80083 9.77667 7.11333 9.84417 7.41083C6.43583 7.24417 3.41917 5.61083 1.3925 3.12167C1.03917 3.73583 0.830833 4.43833 0.830833 5.19417C0.830833 6.61417 1.56167 7.8725 2.6525 8.60167C1.99333 8.58917 1.3475 8.3975 0.8 8.09667V8.14167C0.8 10.1342 2.22083 11.7892 4.085 12.1708C3.75083 12.2625 3.3875 12.3058 3.01 12.3058C2.7475 12.3058 2.4825 12.2908 2.23417 12.2358C2.765 13.8592 4.27333 15.0533 6.065 15.0925C4.67 16.1833 2.89833 16.8408 0.980833 16.8408C0.645 16.8408 0.3225 16.8258 0 16.785C1.81667 17.9558 3.96833 18.625 6.29 18.625C13.5258 18.625 18.2417 12.5883 17.945 6.4275Z",
    fill: "#4B4B4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3254_8530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fb864390269763d86802d0288f5f8183.svg";
export { ForwardRef as ReactComponent };